import { FakeData } from "constants/FakeData";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { NavLink } from "react-router-dom";
import { v4 } from "uuid";
import "styles/Dashboard/DashboardSidebar.sass";
import classNames from "utils/classNames";
import { useDispatch } from "react-redux";
import { handleCloseSidebar } from "store/sidebarReducer/sidebarSlice";
const SidebarMenu = () => {
	return (
		<div className="admin-sidebar-menu flex-1 overflow-auto py-[15px]">
			<ul className="list-menu">
				{FakeData.menu.map((item,index) => {
					return (
						<SidebarMenuLink
							key={index}
							item={item}></SidebarMenuLink>
					);
				})}
			</ul>
		</div>
	);
};
function SidebarMenuLink({ item }) {
	const { title, url, children, icon } = item;
	const dropdownRef = useRef();
	const [dropdown, setDropdown] = useState(false);
	const dispatch = useDispatch()
	const handleClickShowMenu = () => {
		setDropdown(dropdown => !dropdown);
	};
	const closeSidebar = () => {
		console.log('/')
		dispatch(handleCloseSidebar());
	}
	const styleDropdown = {
		height: dropdown ? dropdownRef.current?.offsetHeight : 0,
		transition: "all .3s",
		overflow: "hidden",
		padding: 0,
		visibility: dropdown ? "visible" : "hidden",
	};
	const LinkTitle = !!url ? (
		<NavLink
			className={({ isActive }) =>
				isActive ? "list-link active" : "list-link"
			}
			to={url} onClick={closeSidebar}>
			<em className={icon && icon}></em>
			<span>{title}</span>
		</NavLink>
	) : (
		<div
			className={classNames("list-link", dropdown ? "isOpen" : "")}
			to="#"
			onClick={handleClickShowMenu}>
			<em className={icon && icon}></em>
			<span>{title}</span>
		</div>
	);
	useEffect(() => {
		let hasChildActive = dropdownRef?.current?.querySelector('.list-link.active')
		if (hasChildActive) {
			setDropdown(true)
		}
	},[dropdown])
	return (
		<li className={`list-item ${children ? "has-sub-menu" : ""}`}>
			{LinkTitle}
			{children && (
				<div className="dropdown-menu" style={styleDropdown}>
					<ul className="list-menu" ref={dropdownRef}>
						{children.map(item => (
							<li className="list-item" key={v4()}>
								<NavLink
									className={({ isActive }) =>
										isActive
											? "list-link active"
											: "list-link"
									}
									to={item.url}
									onClick={closeSidebar}
									end>
									{item.title}
								</NavLink>
							</li>
						))}
					</ul>
				</div>
			)}
		</li>
	);
}
export default SidebarMenu;
